import { render, staticRenderFns } from "./CreateRoleModal.vue?vue&type=template&id=31fd4f73&"
import script from "./CreateRoleModal.vue?vue&type=script&lang=ts&"
export * from "./CreateRoleModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports